import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";
import { B2B_DROPDOWN } from "./type";

export const getDropDownData = (leadId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.preB2bAlliance.allianceDropdown}${leadId}`
  );
  if (res) {
    const { data } = res.data.response;
    dispatch({ type: B2B_DROPDOWN, payload: data });
    return data;
  } else {
    return null;
  }
};

export const submitB2bData = (allianceData) => async () => {
  const res = await callWebService(
    callTypes.post,
    allianceData,
    Config.preB2bAlliance.addPreAlliance
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return null;
  }
};
